export default function CameraTestingPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="mb-4 text-3xl font-bold">Test Kamera</h1>
    </div>
  );
}
